import axios from 'axios'
import authHeader from "./services/auth-header";
import router from "./router";
import store from "./store";

function trimEndSlash(value) {
    return value ? value.replace(/\/+$/, "") : value;
}

const runtimeConfig = window.__DOCSAY_CONFIG__ || {};

const apiBaseUrl =
    trimEndSlash(runtimeConfig.API_URL) ||
    trimEndSlash(process.env.VUE_APP_API_URL) ||
    "";

const instance = axios.create({
    baseURL: apiBaseUrl
});

instance.interceptors.request.use(
    (config) => {
        // preserve existing headers (eg. Content-Type) and add auth header
        config.headers = Object.assign({}, config.headers || {}, authHeader());

        // Ensure JSON content-type for requests with a body when not already set
        const hasContentType = Object.keys(config.headers || {}).some(h => h.toLowerCase() === 'content-type');
        if (!hasContentType && config.data && typeof config.data === 'object') {
            config.headers['Content-Type'] = 'application/json;charset=utf-8';
        }

        return config;
    },
    (err) => {
        return Promise.reject(err);
    }
);

instance.interceptors.response.use(
    (response) => {
        if (response.status === 200 || response.status === 201) {
            return Promise.resolve(response);
        }

        return Promise.reject(response);
    },
    (error) => {
        if (error.response && error.response.status) {
            switch (error.response.status) {
                case 401:
                    store.dispatch("auth/logout");
                    router.push("/login");
                    break;
                case 403:
                    router.push("/unauthorized");
                    break;
            }

            return Promise.reject(error.response);
        }

        return Promise.reject(error);
    }
);

export default instance;